import PropTypes from 'prop-types'
import React from 'react'
import { withTheme } from 'styled-components'

import PillLabel from './PillLabel.jsx'

export const FlightLabelStatus = {
  NONE: 0,
  ON_TIME: 1,
  EARLY: 2,
  DELAYED: 3,
  CANCELLED: 4,
  ARRIVED: 5,
  DEPARTED: 6,
  UNKNOWN: 7
}

const FlightLabel = withTheme(({ status, statusText, className, theme }) => {
  const getBackgroundColor = () => {
    switch (status) {
      case FlightLabelStatus.ON_TIME: return theme.colors.statusOpenBackground
      case FlightLabelStatus.EARLY: return theme.colors.statusEarlyBackground
      case FlightLabelStatus.DELAYED: return theme.colors.statusDelayedBackground
      case FlightLabelStatus.CANCELLED: return theme.colors.statusCancelledBackground
      default:
        return theme.colors.statusClosedBackground
    }
  }

  const getColor = () => {
    switch (status) {
      case FlightLabelStatus.ON_TIME: return theme.colors.statusOpenText
      case FlightLabelStatus.EARLY: return theme.colors.statusEarlyText
      case FlightLabelStatus.DELAYED: return theme.colors.statusDelayedText
      case FlightLabelStatus.CANCELLED: return theme.colors.statusCancelledText
      default:
        return theme.colors.statusClosedText
    }
  }

  return !!status &&
    <PillLabel
      backgroundColor={getBackgroundColor()}
      color={getColor()}
      className={className}>
      {statusText}
    </PillLabel>
})

FlightLabel.propTypes = {
  status: PropTypes.number
}

export { FlightLabel }
